import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, UncontrolledTooltip, Modal, ModalHeader, ModalBody, ModalFooter, Label, Badge } from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { selectFilter, textFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import DataEmptyState from '../../commons/dataemptystate';
import NetworkEmptyState from '../../commons/networkemptystate';
import Loader from '../../commons/loader';
import Services from './services';
import { PaginationTotal } from '../../commons/controls';
import { ProgressButton } from '../../commons/ProgressButton';
import RFForm from '../../components/Form/RFForm';
import RFField from '../../components/Form/RFField';
import Lib from '../../commons/lib';

class LeiratkozasTorzs extends Component {
    constructor(props){
        super(props);
        this.state ={
            // ['LOAD', 'DATA', 'NETW', 'TABL']
            tableStatus: 'TABL',
            // ['LOAD', 'DATA', 'NETW']
            formStatus: 'DATA',
            // ['FEL', 'MOD']
            formType: 'FEL',
            // MODAL
            modalForm: false,
            modalDelete: false,
            // BUTTON
            saveButtonLoading: false,
            deleteButtonLoading: false,
            // DATA
            baseJson: [],
            leiratkozasObj: {},
            deleteId: null,
            statusz: [],
            statuszOptions: [],
            filterOptions: {},
        }
    }

    componentDidUpdate(prevProps) {
      if (this.props.active !== prevProps.active) {
        if (this.props.active) {
          this.listLeiratkozasok();
        }
      }
    }

    hasRole = (roles, checkKarb) => {
        return this.props.globals.hasRole(roles, checkKarb);
    }

    listLeiratkozasok = () => {
        Services.listLeiratkozasok((err, res) => {
            if (!err) {
                let filters = {};
                let options = res[0].statusz.map((e) => {
                    filters[e.name] = e.caption;

                    return <option key={e.name} value={e.name}>{e.caption}</option>;
                });

                this.setState({
                    tableStatus: res[0].list.length > 0 ? 'TABL' : 'DATA',
                    baseJson: res[0].list,
                    statusz: res[0].statusz,
                    statuszOptions: options,
                    filterOptions: filters,
                })
            }
        })
    }

    getLeiratkozas = (cell) => {
        let id = cell;
        this.setState({ formStatus: 'LOAD' });
        Services.getLeiratkozas(id, (err, res) => {
            if (!err) {
                res[0].statusz = res[0].statusz.name
                this.setState({
                    formStatus: 'DATA',
                    leiratkozasObj: res[0]
                });
            }
        })
    }

    toggleModalForm = () => {
        this.setState((prevState) => ({ modalForm: !prevState.modalForm }));
    }

    toggleModalDeleteForm = () => {
        this.setState((prevState) => ({ modalDelete: !prevState.modalDelete }));
    }

    deleteLeiratkozas = () => {
        let id = this.state.deleteId;
        this.setState({ deleteButtonLoading: true });
        Services.deleteLeiratkozas(id, (err) => {
            if (!err) {
                this.setState({ deleteButtonLoading: false, deleteId: null });
                this.toggleModalDeleteForm();
                this.listLeiratkozasok();
                this.props.globals.addSuccess('Leirtakozás sikeresen törölve!');
            }
            this.setState({ deleteButtonLoading: false });
        });
    }

    handleNewClick =  () => {
        this.setState({
            formType: 'FEL',
            modalForm: true,
            leiratkozasObj: { statusz: 'AKTIV' }
        });
    }

    handleEditClick =  (cell) => {
        this.setState({
            formType: 'MOD',
            modalForm: true
        })
        this.getLeiratkozas(cell);
    }

    handleDeleteClick = (cell) => {
        this.setState({ 
            deleteId: cell,
            modalDelete: true
        });
    }

    handleInputChange = (e) => {
        let newObj = this.state.leiratkozasObj;
        newObj[e.target.name] = e.target.value;
        this.setState({
            leiratkozasObj: newObj
        });
    }

    renderFormTitle = () => {
        const { formType } = this.state;
        if (formType === 'FEL') {
            return 'Új leiratkozás hozzáadása';
        }
        if (formType === 'MOD') {
            return 'Leiratkozás módosítása';
        }
    }

    renderForm = () => {
        const { leiratkozasObj } = this.state;
        return (
            <React.Fragment>
                <div className="col-md-4">
                    <RFField
                        label="Azonosító: *"
                        name="azonosito"
                        id="azonosito"
                        type="text"
                        required
                        onChange={(e) => this.handleInputChange(e)}
                        value={leiratkozasObj && leiratkozasObj.azonosito}
                        disabled={this.state.formType === 'MOD'}
                    />
                </div>
                <div className="col-md-4">
                    <RFField
                        label="Leiratkozás indoka: *"
                        name="nev"
                        id="nev"
                        type="text"
                        required
                        onChange={(e) => this.handleInputChange(e)}
                        value={leiratkozasObj && leiratkozasObj.nev}
                    />
                </div>
                <div className="col-md-4">
                    <RFField
                        type="select"
                        label="Leiratkozás státusza:"
                        name="statusz"
                        onChange={(e) => this.handleInputChange(e)}
                        value={leiratkozasObj && leiratkozasObj.statusz}
                        selectOptions={this.state.statuszOptions}
                    />
                </div>
            </React.Fragment>
        ); 
    }

    submitForm = () => {
        const { formType } = this.state;
        let submitObj = this.state.leiratkozasObj;
        this.setState({ saveButtonLoading: true });
        if (formType === 'FEL') {
            Services.addLeiratkozas(submitObj, (err) => {
                if (!err) {
                    this.setState({ saveButtonLoading: false });
                    this.toggleModalForm();
                    this.listLeiratkozasok();
                    this.props.globals.addSuccess('Leirtakozás sikeresen hozzáadva!');
                } else {
                    this.setState({ saveButtonLoading: false });
                }
            })
        }
        if (formType === 'MOD') {
            Services.editLeiratkozas(submitObj, (err) => {
                if (!err) {
                    this.setState({ saveButtonLoading: false });
                    this.toggleModalForm();
                    this.listLeiratkozasok();
                    this.props.globals.addSuccess('Leirtakozás sikeresen módosítva!');
                } else {
                    this.setState({ saveButtonLoading: false });
                }
            })
        }
    }

    statusFormatter = (cell, row) => {
      if (row.id) {
        let statusz = this.state.statusz.find(x => x.name === cell);
        return statusz ? <span className={'badge badge-' + statusz.bagde}>{statusz.caption}</span> : 'N/A';
      }

      return <span>Mindig aktív</span>
    }

  tableIconFormatter = (cell, row) => {
    return (
      <div>
        <React.Fragment>
          {this.hasRole(['HIRLEVEL_HIRLEVEL'], true) && row.id && (
            <React.Fragment>
                <Button className="icon-pencil table-action-icon" id={'action-view-' + cell + 'modositas'} onClick={() => this.handleEditClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
                <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'modositas'} delay={50}>
                    {'Módosítás'}
                </UncontrolledTooltip>
                <Button className="icon-trash table-action-icon" id={'action-view-' + cell + 'file'} onClick={() => this.handleDeleteClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
                <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'file'} delay={50}>
                    {'Törlés'}
                </UncontrolledTooltip>
            </React.Fragment>
          )}
        </React.Fragment>
      </div>
    );
  }

    renderTable = () => {
          const columns = [
            {
              dataField: 'nev',
              text: 'Leiratkozás indoka',
              filter: textFilter({
                delay: 400, // default is 500ms
                placeholder: 'Keresés...',
              }),
              style: {
                wordBreak: 'break-all',
                whiteSpace: 'pre-line',
              },
              sort: true
            },
            {
              dataField: 'statusz',
              align: 'center',
              text: 'Állapot',
              filter: selectFilter({
                options: this.state.filterOptions,
                placeholder: 'Összes',
              }),
              formatter: (cell, row) => this.statusFormatter(cell,row),
              style: {
                wordBreak: 'break-all',
                whiteSpace: 'pre-line',
              },
              sort: true
            },
            {
              dataField: 'szam',
              align: 'center',
              text: 'Választva',
              filter: textFilter({
                delay: 400, // default is 500ms
                placeholder: 'Keresés...',
              }),
              style: {
                wordBreak: 'break-all',
                whiteSpace: 'pre-line',
              }
            },
            {
              dataField: 'id',
              text: 'Műveletek',
              hidden: !this.hasRole(['HIRLEVEL_HIRLEVEL'], true),
              formatter: (cell, row) => this.tableIconFormatter(cell, row)
            }
          ];
          return (
            <div className="animated fadeIn">
              <BootstrapTable
                bootstrap4
                keyField="id"
                data={this.state.baseJson}
                columns={columns}
                wrapperClasses="table-responsive"
                classes="table-scroll"
                headerClasses="table-th"
                filter={filterFactory()}
                pagination={paginationFactory(Lib.bootstraptableProps)}
                noDataIndication="Nincs megjelenítendő adat!"
              />
            </div>
          );
    }

    render() {
        return (
        <React.Fragment>
            <div className="row">
                <div className="col-md-12">
                {this.hasRole(['HIRLEVEL_HIRLEVEL'], true) && (
                 <Button onClick={() => this.handleNewClick()} color="primary">Új indok rögzítése</Button>
                )}
                </div>
                <br /><br />
                <div className="col-md-12" />
                <div className="col-md-12">
                {{
                    LOAD: (<Loader />),
                    DATA: (<DataEmptyState
                    hasImage
                    subtitle="Vigyél fel új tételt!"
                    />),
                    NETW: (<NetworkEmptyState
                    hasImage
                    submitClick={() => { this.listLeiratkozasok() }}
                    />),
                    TABL: (this.renderTable())
                }[this.state.tableStatus]
                }
                </div>
            </div>
            <Modal isOpen={this.state.modalForm} toggle={this.toggleModalForm} backdrop="static" size="lg">
                <RFForm
                    modal
                    onSubmit={this.submitForm}
                    title={this.renderFormTitle()}
                    footer={
                        <React.Fragment>
                            <ProgressButton
                                className="btn-cursor-pointer"
                                color="primary"
                                loading={this.state.saveButtonLoading}
                            >
                            {'Mentés'}
                            </ProgressButton>
                            <Button type="button" color="secondary" className="btn-cursor-pointer" onClick={this.toggleModalForm}>Mégsem</Button>
                        </React.Fragment>
                    }
                    >
                        <div className="row">
                            {this.renderForm()}
                        </div>
                </RFForm>
            </Modal>
            <Modal isOpen={this.state.modalDelete} toggle={this.toggleModalDeleteForm} backdrop="static">
                <ModalHeader>Törlés</ModalHeader>
                <ModalBody>Valóban törölni kívánod a kiválasztott tételt?</ModalBody>
                <ModalFooter>
                <ProgressButton
                    className="btn-cursor-pointer"
                    color="primary"
                    onClick={() => this.deleteLeiratkozas()}
                    loading={this.state.deleteButtonLoading}
                >
                    {'Igen'}
                </ProgressButton>
                <Button type="button" color="secondary" onClick={this.toggleModalDeleteForm}>Mégsem</Button>
                </ModalFooter>
            </Modal>
        </React.Fragment>
        );
    }
}

LeiratkozasTorzs.propTypes = {
  globals: PropTypes.object,
  type: PropTypes.string,
  active: PropTypes.bool,
};

export default LeiratkozasTorzs;